import googlePreferredIcon from "@assets/icons/googlePreferredSource.png";
import { WEB2_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { useTablaCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useTablaCustomEventAnalyticsCall";
import { useGooglePreferredSource } from "@sphtech/sph-web-ui";

export type googlePreferedButtonProps = {
  className?: string;
  pageUrl: string;
};

/**
 * A React component that renders a Google Preferred Source Button on Article page
 */
export default function GooglePreferedSourceButton({
  className,
  pageUrl,
}: googlePreferedButtonProps): React.ReactElement {
  const { addPreferredSource } = useGooglePreferredSource({ lang: "en" });
  const tablaCustomGaEvent = useTablaCustomEventAnalyticsCall();

  const handleOnClick = () => {
    tablaCustomGaEvent({
      event: "customEvent",
      clickCategory: "preferred source on google",
      clickAction: "click",
      clickLabel: `${removeTrailingSlash(WEB2_BASE_URL)}${pageUrl}`,
    });
    addPreferredSource();
  };

  return (
    <button className={className} onClick={handleOnClick}>
      <img
        src={googlePreferredIcon}
        alt="google-preferred-source"
        height="39px"
        width="139px"
      />
    </button>
  );
}
